export default __webpack_public_path__ + "2dc3baecc1b6c1fd3518b9813e3c7023.svg";